import { LockFill } from "react-bootstrap-icons";

//Common
import useIconStyles from "./styles";
import { IconProps } from "../../../types";

const LockIcon = (props: IconProps) => {
    const { iconText = "Permissions", pendingText } = props;
    const iconStyles = useIconStyles();

    return (
        <div style={iconStyles.container}>
            <LockFill style={iconStyles.viewIcon} />
            <div style={iconStyles.iconText}>
                {iconText} {pendingText}
            </div>
        </div>
    );
};

export default LockIcon;
